"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.FieldEnableRules = void 0;
/**
 * Evaluates a single rule against the provided data.
 * @param {Object} rule - The rule to evaluate, containing a path and optional conditions.
 * @param {string[]} rule.path - An array of strings representing the path to the value in the data object.
 * @param {any} [rule.is] - An optional condition that specifies the value must be equal to this for the rule to pass.
 * @param {any} [rule.isNot] - An optional condition that specifies the value must not be equal to this for the rule to pass.
 * @param {Record<string, any>} data - The data object to evaluate the rule against.
 * @returns {boolean} - Returns true if the rule is satisfied, otherwise false.
 */
var evaluateRule = function (rule, data) {
    var value = rule.path.reduce(function (obj, key) { return (obj ? obj[key] : undefined); }, data);
    // Check `is` and `isNot` conditions
    return ((rule.is === undefined || value === rule.is) &&
        (rule.isNot === undefined || value !== rule.isNot));
};
/**
 * Evaluates whether the input should be enabled based on the given rule.
 * @param rule - Array of PathAssertion objects that must all evaluate to true for the input to be enabled.
 * @param data - The data object to evaluate the rule against.
 * @param logicType - Select logical operation. If "AND", all rules must be true for the input to be enabled. If "OR", at least one rule must be true for the input to be enabled.
 * @returns {boolean} - True if all assertions are met, otherwise false.
 */
function evaluateEnablerRules(rules, data, logicType // Default to "OR"
) {
    var e_1, _a;
    if (logicType === void 0) { logicType = 'OR'; }
    try {
        // Iterate through the rules with short-circuiting
        for (var rules_1 = __values(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()) {
            var rule = rules_1_1.value;
            var rulePasses = evaluateRule(rule, data);
            if (logicType === 'OR' && rulePasses) {
                return true; // Short-circuit for "OR"
            }
            if (logicType === 'AND' && !rulePasses) {
                return false; // Short-circuit for "AND"
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rules_1_1 && !rules_1_1.done && (_a = rules_1["return"])) _a.call(rules_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // Return the appropriate default based on the logic type
    return logicType === 'AND'; // All rules passed for "AND", or none passed for "OR"
}
exports["default"] = evaluateEnablerRules;
//Exported for testing
exports.FieldEnableRules = {
    evaluateRule: evaluateRule
};
//# sourceMappingURL=field-enabler-rules.js.map